import { render, staticRenderFns } from "./benefitCard.vue?vue&type=template&id=5569f60c&"
import script from "./benefitCard.vue?vue&type=script&lang=js&"
export * from "./benefitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports